/**
 * printlane-guard.js
 * Garde-fou Printlane pour Plaques France Tombale (thème Ella).
 *
 * Problème : Printlane fige le gabarit à l'ouverture du designer (d'après ?variant= dans l'URL,
 * ou la variante initiale), puis, à l'enregistrement, écrit la référence dans un champ caché
 * et soumet nativement le formulaire avec la variante présente à ce moment-là.
 * Rien ne vérifie que les deux correspondent, et le champ caché n'est jamais vidé.
 *
 * Ce script :
 *  1. mémorise la variante utilisée par Printlane au clic sur "Personnalisez" ;
 *  2. bloque l'ajout au panier si le gabarit de la variante envoyée diffère de celui du design ;
 *  3. vide la référence dès que la variante change ;
 *  4. vide la référence quand la page revient du cache navigateur (bouton retour).
 *
 * Installation : assets/printlane-guard.js, puis dans layout/theme.liquid avant </body> :
 *   {% if template.name == 'product' %}
 *     <script src="{{ 'printlane-guard.js' | asset_url }}" defer></script>
 *   {% endif %}
 */
(function () {
  'use strict';

  const FIELD_ID = 'printlane-customization-reference';
  const CLONE_SELECTOR = '.colorlab-atc-clone';
  const MESSAGE_ID = 'printlane-guard-message';
  const POLL_MS = 250;
  const LOG = '[printlane-guard]';
  const MESSAGE =
    'Vous avez modifié la forme ou la fixation après votre personnalisation. ' +
    'Cliquez sur « Personnalisez » pour refaire votre plaque avec les options sélectionnées.';

  function init() {
    const data = window.printlane_shopify_data || window.colorlab_shopify_data;
    if (!data || data.pageType !== 'product') return;
    if (!Array.isArray(data.customizableVariants) || !data.customizableVariants.length) return;

    // Correspondance variante -> gabarit Printlane
    const templates = {};
    let sharedTemplate = false;
    data.customizableVariants.forEach(function (v) {
      if (String(v.variantId) === 'all') sharedTemplate = true;
      templates[String(v.variantId)] = v.templateId;
    });
    // Un seul gabarit pour toutes les variantes : aucune incohérence possible
    if (sharedTemplate) return;

    let openedVariant = null;

    // Même source que Printlane : ?variant= dans l'URL, sinon la variante initiale
    function printlaneVariant() {
      const fromUrl = new URLSearchParams(window.location.search).get('variant');
      return fromUrl || String(data.currentVariantId || '');
    }

    function referenceField() {
      return document.getElementById(FIELD_ID);
    }

    function formVariant(form) {
      const input = form && form.querySelector('[name="id"]');
      return input ? String(input.value) : '';
    }

    function sameTemplate(a, b) {
      if (!a || !b) return true; // pas assez d'information : on ne bloque pas
      const ta = templates[a];
      const tb = templates[b];
      if (ta && tb) return ta === tb;
      return a === b;
    }

    function clearMessage() {
      const box = document.getElementById(MESSAGE_ID);
      if (box) box.remove();
    }

    function showMessage() {
      clearMessage();
      const box = document.createElement('div');
      box.id = MESSAGE_ID;
      box.setAttribute('role', 'alert');
      box.textContent = MESSAGE;
      box.style.cssText =
        'margin:12px 0;padding:12px 16px;border-radius:4px;' +
        'background:#fde8e8;color:#b42318;font-weight:600;line-height:1.4;';
      const anchor = document.querySelector(CLONE_SELECTOR);
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(box, anchor);
      } else {
        document.body.prepend(box);
      }
      // Laisse le designer se fermer avant de faire défiler
      setTimeout(function () {
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    }

    // Renvoie false (et neutralise la référence) si design et variante ne correspondent pas
    function isConsistent(form) {
      const field = form.querySelector('#' + FIELD_ID);
      if (!field || !field.value) return true;

      const submitted = formVariant(form);
      const opened = openedVariant || printlaneVariant();
      if (sameTemplate(opened, submitted)) return true;

      console.warn(LOG, 'design et variante incohérents, ajout au panier bloqué', {
        openedVariant: opened,
        openedTemplate: templates[opened],
        submittedVariant: submitted,
        submittedTemplate: templates[submitted],
        reference: field.value
      });
      field.value = '';
      showMessage();
      return false;
    }

    // 1. Variante utilisée à l'ouverture du designer.
    //    Écoute en capture sur document : passe avant le listener Printlane posé sur le bouton.
    document.addEventListener(
      'click',
      function (e) {
        if (!e.target.closest || !e.target.closest(CLONE_SELECTOR)) return;
        openedVariant = printlaneVariant();
        clearMessage();
      },
      true
    );

    // 2a. Printlane soumet via form.submit(), qui ne déclenche pas l'événement "submit"
    const nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      let ok = true;
      try {
        ok = isConsistent(this);
      } catch (err) {
        console.error(LOG, err); // en cas de bug du garde-fou, on ne bloque jamais la vente
      }
      if (ok) return nativeSubmit.call(this);
    };

    // 2b. Autres soumissions (touche Entrée, requestSubmit, bouton natif)
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        let ok = true;
        try {
          ok = isConsistent(form);
        } catch (err) {
          console.error(LOG, err);
        }
        if (!ok) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    // 3. Référence vidée dès que la variante change (formulaire ou URL)
    let lastFormVariant = null;
    let lastUrlVariant = null;
    setInterval(function () {
      const field = referenceField();
      const currentForm = field ? formVariant(field.form) : '';
      const currentUrl = printlaneVariant();
      const changed =
        lastFormVariant !== null &&
        (currentForm !== lastFormVariant || currentUrl !== lastUrlVariant);
      if (changed && field && field.value) {
        console.info(LOG, 'variante modifiée, référence vidée');
        field.value = '';
      }
      lastFormVariant = currentForm;
      lastUrlVariant = currentUrl;
    }, POLL_MS);

    // 4. Retour arrière : la page revient du cache avec l'ancien état
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      const field = referenceField();
      if (field) field.value = '';
      openedVariant = null;
      clearMessage();
    });

    // Accès de débogage depuis la console
    window.printlaneGuard = {
      state: function () {
        return {
          openedVariant: openedVariant,
          printlaneVariant: printlaneVariant(),
          reference: (referenceField() || {}).value || ''
        };
      },
      check: isConsistent
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();